import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import { initModal } from 'shared/actions/modal.action';

import DotWave from 'shared/components/loading/DotWave';
import Spinner from 'shared/components/loading/spinner';

@connect(
  state => ({ modal: state.shared.modal, loading: state.shared.loading }),
  { initModal },
)
class LoadingContainer extends Component {
  render() {
    const { isDim = true, dotColor, loading } = this.props;
    const { status } = loading;

    const loadingWrapStyle = {
      position: 'relative',
      width: '100%',
      height: '100vh',
    };

    if (!status) return null;

    return (
      <>
        {status === true && (
          <Dim>
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                zIndex: 21000,
              }}
            >
              {/* <DotWave backgroundColor={dotColor} number={3} /> */}
              <Spinner />
            </div>
          </Dim>
        )}
      </>
    );
  }
}

export default LoadingContainer;
